module.exports = __webpack_public_path__ + "img/1590.2c7cba42.png";